import { getCookie } from '@/utils/apiService';
import { useEffect, useState } from 'react';

const usePhoneNumber = () => {
  const [phoneNumber, setPhoneNumber] = useState<string | null>(null);
  const [isCookieLoading, setIsCookieLoading] = useState(true);

  useEffect(() => {
    setPhoneNumber(getCookie('phone_number'));
    setIsCookieLoading(false);
  }, []);

  return { phoneNumber, isCookieLoading };
};

export default usePhoneNumber;